import {
  ClientIcon,
  DashIcon,
  SettingsIcon,
  TrainingIcon,
  TransactionIcon,
} from "./images";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { BsTrash } from "react-icons/bs";
import { PRIVATE_PATHS } from "../../routes/constants";
import { FaEdit } from "react-icons/fa";

export const Statuses = [
  { color: "#F9A11E", name: "Pending", id: "0" },
  { color: "#646668", name: "InProgress", id: "1" },
  { color: "#01765F", name: "Active", id: "2" },
  { color: "#DB0101", name: "Failed", id: "3" },
  { color: "#A11212", name: "Rejected", id: "4" },
];

export const kybReviewStatus = [
  { label: "Approve", id: 2 },
  { label: "Reject", id: 3 },
];

export const clientDash = [
  {
    icon: "/assets/step1.png",
    label: "Business Information",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_1,
  },
  {
    icon: "/assets/step2.png",
    label: "Finance Details",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_2,
  },
  {
    icon: "/assets/step3.png",
    label: "Risk Assessments",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_3,
  },
  {
    icon: "/assets/step4.png",
    label: "Documents Upload 1",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_4,
  },
  {
    icon: "/assets/step4.png",
    label: "Documents Upload 2",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_5,
  },
];

export const indDash = [
  {
    icon: "/assets/step1.png",
    label: "Business Information",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_1,
  },
  {
    icon: "/assets/step2.png",
    label: "Finance Details",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_2,
  },
  {
    icon: "/assets/step3.png",
    label: "Risk Assessments",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_3,
  },
  {
    icon: "/assets/step4.png",
    label: "Documents Upload",
    route: PRIVATE_PATHS.CLIENT_AUTH_STEP_4,
  },
];

export const kycTabs = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Approved",
    value: "approved",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
];

export const tTabs = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
];

export const riskStatus = [
  {
    label: "Low",
    range: "0-30",
    color: "#01765F",
  },
  {
    label: "Medium",
    color: "#FFB60C",
    range: "31-60",
  },
  {
    label: "High",
    range: "61-100",
    color: "#DB0101",
  },
];

export const staffTabs = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
];

export const rolesTab = [
  {
    label: "Department",
    route: "",
  },
  {
    label: "Active",
    route: "active",
  },
  {
    label: "Pending",
    route: "pending",
  },
  {
    label: "Inactive",
    route: "inactive",
  },
];

export const dropdown = [
  { label: "Profile", route: "/profile" },
  { label: "Log Out" },
];

export const viewDeleteOption = [
  {
    name: "View",
    icon: HiOutlineInformationCircle,
  },
  {
    name: "Delete",
    icon: BsTrash,
  },
];

export const viewStatOption = [
  {
    name: "View",
    icon: HiOutlineInformationCircle,
  },
  {
    name: "Edit",
    icon: FaEdit,
  },
];

export const TransactionStatus = [
  { color: "#000", name: "All", id: "" },
  { color: "#F9A11E", name: "Pending", id: "0" },
  { color: "#646668", name: "InProgress", id: "1" },
  { color: "#01765F", name: "Completed", id: "2" },
  { color: "#DB0101", name: "Failed", id: "3" },
  { color: "#A11212", name: "Rejected", id: "4" },
];

export const KycStatus = [
  { name: "pending", bg: "#FFB60C" },
  { name: "pendinginvite", bg: "#FFB60C", label: "Pending Invite" },
  { name: "approved", bg: "#01765F" },
  { name: "rejected", bg: "#DB0101" },
];

export const AdminStatus = [
  { name: "pending", bg: "#FFB60C" },
  { name: "active", bg: "#01765F" },
  { name: "inactive", bg: "#DB0101" },
];

export const clientRoutes = [
  {
    id: 0,
    name: "Dashboard",
    path: "/client/dashboard",
    icon: <DashIcon />,
  },
];

export const adminRoutes = [
  {
    id: 0,
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: <DashIcon />,
  },

  {
    id: 1,
    name: "Clients",
    icon: <ClientIcon />,
    path: "/admin/clients",
    sub: [
      {
        label: "New Clients",
        route: "/admin/clients/new-clients",
      },
      {
        label: "KYC",
        route: "/admin/clients/kyc",
      },
    ],
  },

  {
    id: 2,
    name: "Transactions",
    path: "/admin/transactions",
    icon: <TransactionIcon />,
    sub: [
      {
        label: "All Transactions",
        route: "/admin/transactions/all",
      },
      {
        label: "Pre-Approvals",
        route: "/admin/transactions/pre-approvals",
      },
    ],
  },

  // {
  //   id: 3,
  //   name: "Audits",
  //   path: "/audits",
  //   icon: <TrainingIcon />,
  //   sub: [
  //     {
  //       label: "Account Management",
  //       route: "/admin/audits/account-mgt",
  //     },
  //     {
  //       label: "Transaction Management",
  //       route: "/admin/audits/transaction-mgt",
  //     },
  //   ],
  // },

  {
    id: 4,
    name: "Settings",
    path: "/admin/settings",
    icon: <SettingsIcon />,
    sub: [
      {
        label: "Staffs",
        route: "/admin/settings/staffs",
      },
      {
        label: "Managed Roles",
        route: "/admin/settings/roles/departments",
      },
      // {
      //   label: "Issues",
      //   route: "/settings/issues",
      // },
      {
        label: "Extras",
        route: "/admin/settings/extras/countries",
      },
    ],
  },
];

export const altCustomStyles = () => ({
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    minHeight: "44px",
    color: "#0C0D10",
    fontSize: "16px",
    cursor: "pointer",
    borderRadius: "8px",
    border: "none",
    paddingRight: "16px",
    background: state.hasValue ? "#F1F8FB" : "unset",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "15px",
    backgroundColor: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "" : "",
    cursor: "pointer",
    backgroundColor: state.isFocused ? "#F8FDFC" : "",
  }),
});

export const customStyles = (error) => ({
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    minHeight: "44px",
    color: error ? "#EE383A" : "#0C0D10",
    fontSize: "16px",
    cursor: "pointer",
    borderRadius: "8px",
    border: error
      ? "1px solid red"
      : state.hasValue
        ? "1px solid #080761"
        : "1px solid #C5C5CF",
    paddingRight: "16px",
    background: error ? "#FDE8E8" : state.hasValue ? "#F1F8FB" : "unset",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "15px",
    backgroundColor: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "" : "",
    cursor: "pointer",
    backgroundColor: state.isFocused ? "#F8FDFC" : "",
  }),
});

export const staffStatus = [
  { color: "#000", name: "All", id: "" },
  { color: "#F9A11E", name: "Pending", id: "0" },
  { color: "#646668", name: "InProgress", id: "1" },
  { color: "#01765F", name: "Completed", id: "2" },
  { color: "#DB0101", name: "Failed", id: "3" },
  { color: "#A11212", name: "Rejected", id: "4" },
];

export const industry = [
  {
    title: "High Risk (20-25)",
    list: [
      { id: 1, label: "Cryptocurrency" },
      { id: 2, label: "Gambling/Gaming" },
      { id: 3, label: "Adult Content" },
      { id: 4, label: "Arms/Defense" },
      { id: 5, label: "Precious metals/stones" },
    ],
  },
  {
    title: "Medium Risk (15-19)",
    list: [
      { id: 6, label: "Money Service" },
      { id: 7, label: "Foreign Exchange" },
      { id: 8, label: "Travel agencies" },
      { id: 9, label: "Digital good" },
      { id: 10, label: "High value electronics" },
    ],
  },
  {
    title: "Low Risk (0-9)",
    list: [
      { id: 11, label: "Local retail" },
      { id: 12, label: "Food/Beverage" },
      { id: 13, label: "Healthcare" },
      { id: 14, label: "Education" },
    ],
  },
];

export const pep = [
  { id: 1, title: "Direct PEP ownership (20-25)" },
  { id: 1, title: "PEP beneficial ownership (16-19)" },
  { id: 1, title: "PEP connected directors (10-15)" },
  { id: 1, title: "Close associate to PEP (5-9)" },
  { id: 1, title: "No PEP connection (0-4)" },
];

export const trans = [
  { id: 1, title: "Over #100M monthly (16-20)" },
  { id: 1, title: "#50M - #100M monthly (11-15)" },
  { id: 1, title: "#10M - #50M monthly (6-10)" },
  { id: 1, title: "Under #10M monthly (0-5)" },
];

export const geo = [
  { id: 1, title: "Multiple high-risk countries (12-15)" },
  { id: 1, title: "Single high-risk (8-11)" },
  { id: 1, title: "Multiple low-risk countries (4-7)" },
  { id: 1, title: "Local only (0-3)" },
];

export const business = [
  { id: 1, title: "Less than 1 year (12-15)" },
  { id: 1, title: "1-3 years (8-11)" },
  { id: 1, title: "3-5 years (4-7)" },
  { id: 1, title: "Over 5 years (0-3)" },
];

export const dashCards = [
  { label: "Total KYC Counts", img: "/assets/step-1.png" },
  { label: "Total Pending KYC", img: "/assets/step-2.png" },
  { label: "Today's Transaction Volume", img: "/assets/step-3.png" },
  { label: "Today's Transaction Volume", img: "/assets/step-4.png" },
];

export const currencySymbols = {
  NGN: "₦",
  Naira: "₦",

  USD: "$",
  Dollar: "$",
  Dollars: "$",

  EUR: "€",
  Euro: "€",

  GBP: "£",
  Pound: "£",
  Pounds: "£",
};
